import { CountriesOptions } from '../../../components/form/countriesoptions.js'
import { FormComponent } from '../../../components/form/form.js'
import { initRequest } from '../../js/utils/request'

initRequest()
FormComponent().init()
CountriesOptions().init()
